import { pxToRem } from '../../../../utils';
var carouselItemStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      width: pxToRem(v.width),
      ':focus': {
        outline: 'none'
      }
    };
  }
};
export default carouselItemStyles;
//# sourceMappingURL=carouselItemStyles.js.map
